'use strict'

const fontMetaData = require('./fontMetaData')
const fontUtils = require('./fontUtils')

module.exports = fontUtils(fontMetaData)